import React, {useCallback, useState} from "react";

import {useHistory} from "react-router-dom";

import {PageType} from "shared/constants/PageType";

import {RouteUrls} from "routing/routing.constants";

import {FormFieldsModel} from "pages/ContactUs/models";

import {ConfigCenterContext} from "./ConfigCenterContext";

const pagesRoutesMap = new Map<PageType, RouteUrls>([
  [PageType.MAIN, RouteUrls.ROOT_URL],
  [PageType.CONTACT_US, RouteUrls.CONTACT_US_URL],
  [PageType.PRIVACY_POLICY, RouteUrls.PRIVACY_POLICY_URL],
  [PageType.TERMS_OF_USE, RouteUrls.TERMS_OF_USE_URL],
  [PageType.OUR_PROCESS, RouteUrls.OUR_PROCESS_URL],
  [PageType.COOKIE_POLICY, RouteUrls.COOKIE_POLICY_URL],
  [PageType.GAME_RULES, RouteUrls.GAME_RULES_URL],
  [PageType.BUY_NFT, RouteUrls.BUY_NFT_URL],
  [PageType.FOR_INFLUENCERS, RouteUrls.FOR_INFLUENCERS_URL],
  [PageType.WAX_WALLET, RouteUrls.WAX_WALLET_URL],
]);

export const ConfigCenterProvider: React.FC = React.memo(({ children }) => {
  const history = useHistory();
  const [visibleMenuPanel, setVisibleMenuPanel] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formValues, setFormValues] = useState<FormFieldsModel>();

  const [activePage, setActivePage] = useState(PageType.MAIN);

  const toggleMenuPanel = useCallback(() => {
    setVisibleMenuPanel((prev) => !prev);
  }, []);

  const changePage = useCallback(
    (page: PageType, scrollCb?: () => void, event?: React.MouseEvent<HTMLAnchorElement>) => {
      if (event) {
        if (
          event.defaultPrevented || event.button !== 0 ||
          event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
          (event.currentTarget.target && event.currentTarget.target !== "_self")
        ) {
          return;
        }
        event.preventDefault();
      }

      history.push(event?.currentTarget.getAttribute("href") ?? pagesRoutesMap.get(page) ?? RouteUrls.ROOT_URL);
      setVisibleMenuPanel(false);
      if (scrollCb) {
        setTimeout(() => scrollCb(), 100);
      } else {
        window.scroll({ top: 0, behavior: "smooth" });
      }
    },
    [history]
  );

  return (
    <ConfigCenterContext.Provider
      value={[
        { visibleMenuPanel, activePage, isLoading, formValues },
        { toggleMenuPanel, changePage, setIsLoading, setFormValues },
      ]}
    >
      {children}
    </ConfigCenterContext.Provider>
  );
});
